module.exports = __webpack_public_path__ + "img/hero-h5.e2989cc3.webp";